import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class;
import { NOT_LOGGED_IN_USER_ID } from './constants';
import { OidcTokenStorage } from './storage';
import { TokenClient } from './TokenClient';
import { TokenRoutes } from './TokenRoutes';
export class TokenService {
  constructor() {
    _defineProperty(this, "oidcTokenStorage", new OidcTokenStorage());
    // TODO: remove when this is fixed: https://github.com/microsoft/TypeScript/issues/53305
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- false positive
    TokenService.instance ??= this;

    // eslint-disable-next-line no-constructor-return -- needed for the singleton pattern
    return TokenService.instance;
  }
  static getInstance() {
    return new this();
  }
  async getAuthorizationToken(customerId) {
    let token = null;
    const userId = typeof customerId === 'string' ? Number(customerId) : customerId;
    if (userId !== NOT_LOGGED_IN_USER_ID) {
      token = await this.getTokenServiceUserToken();
      if (!token) {
        token = this.getSessionStorageToken();
      }
    }
    if (!token) {
      token = await this.getTokenServicePublicToken();
    }
    if (!token) {
      throw new Error('Token is missing!');
    }
    return token;
  }
  getSessionStorageToken() {
    const token = this.oidcTokenStorage.getAccessToken();
    if (token) {
      return token.toString();
    }
    return null;
  }
  async getTokenServiceUserToken() {
    const result = await TokenService.userTokenClient.getToken();
    return result?.Token ?? null;
  }
  async getTokenServicePublicToken() {
    const result = await TokenService.publicTokenClient.getToken();
    return result?.Token ?? null;
  }
}
_class = TokenService;
_defineProperty(TokenService, "instance", void 0);
// Create token clients just once - no need to create them every time TokenService is created
_defineProperty(TokenService, "userTokenClient", new TokenClient({
  url: TokenRoutes.USER_ACCESS,
  requestOptions: {
    method: 'GET'
  }
}));
_defineProperty(TokenService, "publicTokenClient", new TokenClient({
  url: TokenRoutes.PUBLIC_ACCESS,
  requestOptions: {
    method: 'GET'
  }
}));
//# sourceMappingURL=TokenService.js.map